import _ from 'lodash';
import { VuexModule, Module, Action, Mutation } from "vuex-module-decorators";
import Menu from "@/model/menu";
import { Setting } from "@/model/menuSetting";

@Module({ namespaced: true })
export default class MenuModule extends VuexModule {
  public menu: Menu = null;
  public menuList: Menu[] = [];
  public setting: Setting = null;

  public allRawMenuList: Menu[] = [];

  @Mutation
  set(menu: Menu): void {
    this.menu = menu;
  }

  @Mutation
  setMenuList(menu: Menu[]): void {
    this.menuList = menu;
  }

  @Mutation
  resetMenuQuantity(): void {
    const current = this.menuList;

    this.menuList = _.map(current, item => {
      item.quantity = 1;

      return item;
    })

    this.allRawMenuList = _.map(this.allRawMenuList, item => {
      item.quantity = 1;

      return item;
    });
  }

  @Mutation
  setRawMenuList(menus: Menu[]): void {
    this.allRawMenuList = menus;
  }

  @Mutation
  addMenuList(menus: Menu[]): void {
    this.menuList = menus;
  }

  @Mutation
  SetMenuSetting(setting: Setting): void {
    this.setting = setting;
  }

  @Mutation
  getAMenu(identifier: any): Menu {
    let response = new Menu()
    this.menuList.map(value => {
      if (value.identifier === identifier) {
        response = value
      }
    })

    return response
  }

  @Mutation
  editMenuList(menu: Menu): void {
    this.menuList.map((value, key) => {
      if (value.identifier === menu.identifier) {
        this.menuList.splice(key, 1, menu)
      }
    });
  }

  @Mutation
  remove(index: number): void {
    this.menuList.splice(index, 1);
  }

  @Action({ rawError: true })
  setMenu(menu: Menu) {
    this.context.commit("set", menu);
  }

  @Action({ rawError: true })
  addMenuToList(menus: Menu[]) {
    this.context.commit("addMenuList", menus);
  }

  @Action({ rawError: true })
  addRawMenusToList(menus: Menu[]) {
    this.context.commit("setRawMenuList", menus);
  }

  @Action({ rawError: true })
  setMenuSetting(setting: Setting) {
    this.context.commit("SetMenuSetting", setting);
  }

  @Action({ rawError: true })
  editMenuToList(menu: Menu) {
    this.context.commit("editMenuList", menu);
  }

  @Action({ rawError: true })
  removeMenuInList(index: number) {
    this.context.commit("remove", index);
  }

  @Action({ rawError: true })
  clear() {
    this.context.commit("set", null);
  }

  @Action({ rawError: true })
  clearList() {
    this.context.commit("setMenuList", []);
  }

  @Action({ rawError: true })
  clearQuantity() {
    this.context.commit("resetMenuQuantity");
  }

  get getMenu(): Menu {
    return this.menu;
  }

  get getMenuList(): Menu[] {
    return this.menuList;
  }

  get getRawMenuList(): Menu[] {
    return this.allRawMenuList;
  }

  get getMenuSetting(): Setting {
    return this.setting;
  }

  get isShowNotAllYouCanEatMobile(): boolean {
    return this.setting?.showNotAllYouCanEatMobile === "1";
  }

  get isShowStaffCall(): boolean {
    return this.setting?.showCallStaffMobile !== "1";
  }

  get isShowRanking(): boolean {
    return this.setting?.showRankingMobile !== "1";
  }

  @Action({ rawError: true })
  getAllMenu() {
    return this.getMenuList
  }

  @Action({ rawError: true })
  getMenuOnList(identifier: any) {
    let response = new Menu()
    this.menuList.map(value => {
      if (value.identifier === identifier) {
        response = value
      }
    })

    return response
  }

  @Mutation
  setQuantity(value: any): void {
    this.menuList.map(item => {
      if (item.identifier === value.identifier) {
        item.quantity = value.quantity
      }
    })
  }

  @Action({ rawError: true })
  setQuantityToMenuItem(value: any) {
    this.context.commit("setQuantity", value);
  }
}
